export const Nascar = () => {
  return (
    <div>
      <div
        className=""
        id="nascarModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="contactModalLabel"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-lg-6">
                  <div className="col-lg-8">
                    <img
                      className="profile-image"
                      id="imageMainNascar"
                      src="/images/executioners/nascar-modal.png"
                      alt="NASCAR licensing presentation"
                      style={{ margin: "10px 0" }}
                    />
                  </div>
                  <div className="col-lg-4">
                    <img
                      className="imageSubNascar"
                      src="/images/executioners/nascar1.png"
                      alt="NASCAR presentation detail"
                      style={{ height: "30%", width: "65%", margin: "10px 0" }}
                    />
                    <img
                      className="imageSubNascar"
                      src="/images/executioners/nascar2.png"
                      alt="NASCAR presentation detail"
                      style={{ height: "30%", width: "65%", margin: "10px 0" }}
                    />
                    <img
                      className="imageSubNascar"
                      src="/images/executioners/nascar3.png"
                      alt="NASCAR presentation detail"
                      style={{ height: "30%", width: "65%", margin: "10px 0" }}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="modal-title-container">
                    <h4 className="modal-title" id="contactModalLabel">
                      NASCAR
                    </h4>
                  </div>
                  <div className="modal-body-container">
                    <p className="helvetica-nueue">
                      <strong>OBJECTIVE</strong>
                    </p>
                    <p>
                      NASCAR already extraordinary with Brand Reach wanted to
                      extend their world- className licensing program to more
                      sophisticated merchants and merchandise. What in the world
                      did NASCAR lack that kept them from doing that? A clear,
                      tastefully designed sales presentation that emphasized
                      NASCAR power in a Noise-free enviorment”
                    </p>
                    <p className="helvetica-nueue">
                      <strong>SOLUTION:</strong>
                    </p>
                    <p>
                      <strong>“Put a muffler on it.”</strong>
                    </p>
                    <p>
                      The large format book that details all aspects of the
                      NASCAR story and the power of its name and brand presents
                      a sleeker style and a less cluttered face to potential
                      licensees.
                    </p>
                    <p>
                      Black &amp; White photos and san serif colored type create
                      a subtle style which suggests a fashion magazines while
                      showing off the muscle of the brand. The message within
                      relied on statistics rather than hyperbole. The target for
                      expansion was two vendors in year one. Employing primarily
                      this promotion piece and the information within, NASCAR
                      added four new licensee, including prestigious Goodyear
                      Tire.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
